
export const milieuForm = [
   {
      name: "preisniveau",
      heading: "Preisniveau im lokalen Vergleich",
      pflicht: true,
      options: [
         "deutlich unter Marktniveau",
         "leicht unter Marktniveau",
         "marktüblich",
         "leicht über Marktniveau",
         "deutliches Premiumsegment",
      ],
   },
   {
      name: "gesamtzustand",
      heading: "Gesamtzustand",
      pflicht: true,
      options: [
         "neuwertig / bezugsfertig",
         "gepflegt, kleinere Arbeiten",
         "Modernisierungsstau in Teilbereichen",
         "umfassender Sanierungsbedarf",
         "Kernsanierung nötig / Rohzustand",
      ],
   },
   {
      name: "ausstattungsniveau",
      heading: "Ausstattungsniveau",
      pflicht: true,
      options: ["einfach", "standard", "gehoben", "premium"],
   },
   {
      name: "barrierefreiheit",
      heading: "Barrierefreiheit",
      options: [
         "barrierefrei (schwellenlos, Aufzug/EG)",
         "barrierearm, Wohnen im EG möglich",
         "eingeschränkt (Treppen, Schwellen)",
         "nicht barrierearm (mehrgeschossig, steile Treppe)",
      ],
   },
   {
      name: "lagecharakter",
      heading: "Charakter der Mikrolage",
      pflicht: true,
      options: [
         "ruhige Wohnstraße / Sackgasse",
         "gewachsenes bürgerliches Viertel",
         "Neubaugebiet",
         "zentral / urban",
         "Stadtrandlage im Grünen",
         "ländlich / dörflich",
         "verkehrsnahe Hauptstraße",
      ],
   },
   {
      name: "laermbelastung",
      heading: "Lärmbelastung",
      options: ["sehr ruhig", "ruhig", "mäßig hörbar", "spürbar belastet"],
   },
   {
      name: "aussicht",
      heading: "Aussicht",
      options: ["keine besondere", "Grün- / Gartenblick", "Fern- / Bergblick", "Stadtblick", "Wasserblick"],
   },
   {
      name: "ausrichtung",
      heading: "Ausrichtung Hauptwohnbereich / Außenbereich",
      options: ["Süd", "Südwest", "West", "Südost", "Ost", "Nord", "unklar"],
   },
   {
      name: "aussenbereichQualitaet",
      heading: "Qualität des Außenbereichs",
      options: [
         "sehr aufwendig angelegte und gepflegte Gartenanlage",
         "durchschnittliche gepflegter Garten",
         "einfacher Rasengarten",
         "naturnah / pflegeleicht",
         "verwildert, Gestaltung nötig",
         "nur Terrasse",
         "nur Balkon",
         "kein Außenbereich",
      ],
   },
   {
      name: "nutzungsszenario",
      heading: "Nutzungsszenario für den Käufer",
      pflicht: true,
      options: [
         "reine Eigennutzung",
         "Kapitalanlage",
         "beides denkbar",
         "Mehrgenerationen / teilweise Eigennutzung",
         "Entwicklung / Weiterverkauf",
      ],
   },
   {
      name: "verkaeuferdruck",
      heading: "Zeitdruck des Verkäufers",
      intern: true,
      options: ["kein Zeitdruck", "moderat", "hoch", "sehr hoch"],
   },
   {
      name: "verkaufsanlass",
      heading: "Verkaufsanlass",
      intern: true,
      options: [
         "Umzug / berufliche Veränderung",
         "Familienzuwachs / Vergrößerung",
         "Verkleinerung im Alter",
         "Erbfall",
         "Trennung / Scheidung",
         "Portfolioumschichtung",
         "sonstiges",
      ],
   },
   {
      name: "alleinstellungsmerkmal",
      heading: "Stärkstes Alleinstellungsmerkmal",
      pflicht: true,
      options: [
         "Charakter & Substanz",
         "Ausstattung & Technik",
         "Größe & Raumangebot",
         "Grundstück & Garten",
         "Lage",
         "Aussicht",
         "Energie & Nachhaltigkeit",
         "Preis-Leistung",
         "Entwicklungspotenzial",
      ],
   },
   {
      name: "kaeuferresonanz",
      heading: "Bisherige Käuferresonanz bei vergleichbaren Objekten",
      intern: true,
      multi: true,
      options: [
         "junge Familien",
         "etablierte Familien",
         "Paare ohne Kinder",
         "Singles",
         "Senioren / Verkleinerer",
         "Kapitalanleger",
         "Handwerker / Entwickler",
         "keine Erfahrungswerte",
      ],
   },
   /* {
      name: "milieuOverride",
      heading: "Milieu manuell festlegen (überschreibt die Ableitung)",
      intern: true,
      options: [
         "automatisch bestimmen",
         "Konservativ-Gehoben",
         "Postmateriell",
         "Performer",
         "Expeditiv",
         "Neo-Ökologisch",
         "Adaptiv-Pragmatische Mitte",
         "Konsum-Hedonistisch",
         "Nostalgisch-Bürgerlich",
         "Traditionell",
         "Prekär",
      ],
   }, */
   { name: "wichtigeHinweise", heading: "Erwähnenstwerte Besonderheiten", textarea: true, width: 12 },
   {
      name: "sonstigeHinweise",
      heading: "Sonstige Punkte die in den Text gehören",
      hinweis: "Stichpunkte sind ausreichend",
      textarea: true,
      width: 12,
   },
];

/**
 * Prompt zur Milieu-Bestimmung
 *
 * Verwendung:
 *   const prompt = milieuPrompt.replace("$DATEN", JSON.stringify(datenObjekt, null, 2));
 *
 * In $DATEN gehören zusammengeführt:
 *   - die Objektstammdaten (Objektart, Baujahr, Wohnfläche, Zimmer, Heizung,
 *     Energieeffizienzklasse, Grundstück, Highlights/Mankos usw.)
 *   - die Antworten aus milieuForm
 *   - optional die aus Google Places abgeleiteten Umfelddaten
 *
 * Nicht ausgefüllte Felder einfach weglassen oder auf null setzen —
 * das Modell ist angewiesen, fehlende Werte als Unsicherheit zu behandeln
 * und sie nicht zu erfinden.
 */

export const milieuPrompt = `
Du bist ein Analyst für Immobilienmarketing mit fundierter Kenntnis der Sinus-Milieus.
Deine Aufgabe ist NICHT, ein Exposé zu schreiben, sondern ausschließlich zu bestimmen,
welches Zielmilieu für die Vermarktung dieser Immobilie am wahrscheinlichsten ist.
Dein Ergebnis dient als Steuerungsinformation für einen nachgelagerten Texterstellungs-Prompt.

### EINGABEDATEN
$DATEN

### VERFÜGBARE MILIEUS
Konservativ-Gehoben, Postmateriell, Performer, Expeditiv, Neo-Ökologisch,
Adaptiv-Pragmatische Mitte, Konsum-Hedonistisch, Nostalgisch-Bürgerlich,
Traditionell, Prekär.
Du darfst ausschließlich aus dieser Liste wählen. Keine Eigenerfindungen, keine Mischformen
als Einzelwert.

### VORRANGREGEL
Enthalten die Daten das Feld "milieuOverride" mit einem anderen Wert als
"automatisch bestimmen", übernimm diesen Wert als Primärmilieu mit Konfidenz 100 und
setze "quelle" auf "manuell". Führe die übrige Analyse trotzdem aus und begründe,
ob die Objektdaten diese Festlegung stützen oder ihr widersprechen.

### ARBEITSSCHRITTE

1. AUSSCHLUSS
Schließe zuerst Milieus aus, die durch harte Widersprüche unmöglich werden.
Ein Ausschluss ist stärker als jedes positive Signal.
- Konsum-Hedonistisch: ausgeschlossen bei umfassendem Sanierungsbedarf oder Kernsanierung.
  Dieses Milieu ist aufwandsscheu; ein Projektobjekt ist kein Genussobjekt.
- Neo-Ökologisch: ausgeschlossen, wenn keinerlei belegbare Energieargumente vorliegen
  (keine gute Energieeffizienzklasse, keine PV, keine Wärmepumpe, kein saniertes Dämmniveau).
  Nachhaltigkeit ohne Beleg ist für dieses Milieu unglaubwürdig.
- Performer und Konservativ-Gehoben: ausgeschlossen bei Ausstattungsniveau "einfach"
  oder Preisniveau unter Marktniveau.
- Prekär: ausgeschlossen bei Preisniveau "leicht über Marktniveau" oder "Premiumsegment"
  sowie bei Ausstattungsniveau "premium".
- Postmateriell: ausgeschlossen bei Neubaugebiet in Kombination mit Standardausstattung
  ohne Charaktermerkmale.
- Expeditiv: ausgeschlossen, wenn das Objekt neuwertig/bezugsfertig ist und kein
  Entwicklungspotenzial als Alleinstellungsmerkmal genannt wird.
- Nostalgisch-Bürgerlich und Traditionell: ausgeschlossen, wenn das Nutzungsszenario
  reine Kapitalanlage ist.
- Traditionell: ausgeschlossen bei betont moderner oder unkonventioneller Objektprägung.

2. GEWICHTUNG
Bewerte die verbleibenden Milieus anhand der folgenden Signalstärken.
Sehr stark: Preisniveau, Gesamtzustand, Ausstattungsniveau, Nutzungsszenario,
Alleinstellungsmerkmal, bisherige Käuferresonanz.
Stark: Lagecharakter, Objekttyp und Größe, Energiestandard, Baujahr, Barrierefreiheit,
Qualität des Außenbereichs.
Unterstützend: Aussicht, Ausrichtung, Lärmbelastung, Zimmerzahl, Ausstattungsdetails.
Nur für Tonalität und Call-to-Action relevant, nie für die Milieuwahl:
Zeitdruck des Verkäufers, Verkaufsanlass.

Orientierungspunkte für die Zuordnung:
- Konservativ-Gehoben: hochwertig, wertbeständig, gewachsene Lage, echte Materialien,
  gehobenes bis Premium-Niveau, Substanz vor Trend.
- Postmateriell: Charakter und Originalsubstanz, Individualität, Bildungsbürgerliches,
  Preis eher gehoben, aber nie statusgetrieben.
- Performer: modern oder Neubau, Premiumausstattung, Technik, Toplage, hohes Preisniveau,
  Zahlen- und Effizienzorientierung.
- Expeditiv: Potenzial, Wandelbarkeit, offene oder unkonventionelle Struktur,
  Entwicklungsobjekte, Gestaltungsspielraum als Hauptargument.
- Neo-Ökologisch: belegbare Energiewerte, sanierter Bestand, PV oder Wärmepumpe,
  gute ÖPNV-Anbindung, Sachlichkeit statt Statusversprechen.
- Adaptiv-Pragmatische Mitte: bezugsfertig, funktional, Standard bis gehoben,
  marktübliches Preisniveau, gute Anbindung, Familien- und Alltagstauglichkeit.
- Konsum-Hedonistisch: bezugsfertig und komfortabel, Terrasse, Lounge, Pool, Wellness,
  sichtbares Lebensgefühl, kein Aufwand.
- Nostalgisch-Bürgerlich: Familienhaus mit Garten, gepflegt, klassisch, ruhige Nachbarschaft,
  Sicherheit und Geborgenheit, mittleres Preisniveau.
- Traditionell: schlicht, überschaubar, pflegeleicht, barrierearm, ruhig, preisbewusst,
  häufig ältere Erst- oder Umsteigerkäufer.
- Prekär: einfaches bis Standardniveau, Preisniveau unter Markt, Funktionalität und
  Transparenz vor Anspruch.

3. KONFIDENZ
Berechne die Konfidenz zwischen 0 und 100 und senke sie systematisch:
- pro fehlendem Pflichtfeld (preisniveau, gesamtzustand, ausstattungsniveau,
  lagecharakter, nutzungsszenario, alleinstellungsmerkmal) um 12 Punkte
- um weitere 15 Punkte, wenn der Abstand zwischen Primär- und Sekundärmilieu gering ist
- um 10 Punkte bei widersprüchlichen Signalen (z. B. Premiumausstattung bei
  Preisniveau unter Marktniveau)
Liegt die Konfidenz unter 60, kennzeichne das Ergebnis ausdrücklich als vorläufig und
empfiehl, zwei Exposé-Varianten zu testen.

### HARTE REGELN
- Erfinde keine Daten. Fehlende Angaben bleiben fehlend und senken die Konfidenz.
  Schlussfolgerungen müssen sich auf konkrete Eingabewerte stützen.
- Als "intern" gekennzeichnete Angaben, insbesondere Verkaufsanlass, Zeitdruck des
  Verkäufers und Käuferresonanz, dürfen niemals in kundensichtbaren Text einfließen.
  Sensible Anlässe wie Trennung, Scheidung oder Erbfall darfst du in keinem Feld
  wörtlich oder umschrieben wiedergeben.
- Nenne die genaue Adresse nicht.
- Das Feld "maklerBriefing" richtet sich an Makler ohne Milieu-Vorkenntnisse. Schreibe dort
  in klarer Alltagssprache, ohne Soziologie- oder Marketingjargon, ohne Aufzählung von
  Milieumerkmalen und ohne den Milieunamen zu wiederholen. Beschreibe konkrete Menschen
  und ihr Verhalten, nicht eine abstrakte Kategorie.
- Antworte ausschließlich mit gültigem JSON, ohne Markdown, ohne Codeblock-Zeichen,
  ohne Einleitung und ohne Nachbemerkung.

### AUSGABEFORMAT
{
  "primaerMilieu": "Name aus der Liste",
  "konfidenz": 0,
  "quelle": "abgeleitet oder manuell",
  "sekundaerMilieu": "Name aus der Liste oder null",
  "sekundaerKonfidenz": 0,
  "varianteEmpfohlen": true,
  "zielgruppe": "kurze konkrete Beschreibung des wahrscheinlichsten Käufers",
  "maklerBriefing": {
    "kurzbeschreibung": "zwei bis drei Sätze in einfacher Alltagssprache: wer diese Menschen sind und wie sie leben",
    "wasIhnenWichtigIst": [
      "drei bis vier Punkte, worauf diese Käufer beim Objekt tatsächlich achten"
    ],
    "wieAnsprechen": "ein bis zwei Sätze, wie der Makler im persönlichen Gespräch und bei der Besichtigung auftreten sollte",
    "wasAbschreckt": [
      "zwei bis drei Punkte, was diese Käufer im Gespräch oder Text sofort abschreckt"
    ]
  },
  "begruendung": [
    "je ein Satz pro tragendem Signal, mit Bezug auf den konkreten Eingabewert"
  ],
  "gegenargumente": [
    "Signale, die gegen das gewählte Primärmilieu sprechen"
  ],
  "ausgeschlossen": [
    { "milieu": "Name", "grund": "kurzer Grund" }
  ],
  "fehlendePflichtfelder": ["Feldnamen"],
  "datenLuecken": [
    "Angaben, die die Zuordnung deutlich verbessern würden"
  ],
  "textsteuerung": {
    "tonalitaet": "kurze Anweisung für den Schreibstil",
    "argumenteZuerst": ["maximal drei Argumente in Reihenfolge der Wirkung"],
    "begriffeBevorzugt": ["Begriffe"],
    "begriffeVermeiden": ["Begriffe"],
    "ctaEmpfehlung": "Art des Abschlusses passend zum Milieu",
    "heikelPunkte": ["Objektschwächen und wie sie sprachlich einzuordnen sind"]
  }
}
`;

export const milieuTexte = {
   "selbstständig erkennen": {
      text: `Zielgruppe bestimmen (intern)

Leite aus den Daten die wahrscheinlichste Zielgruppe ab und richte Tonalität und Argumente darauf aus:
- Familien → Platz, Garten, Schul-/Kita-Nähe, ruhige Lage
- Kapitalanleger → Rendite, Mietverhältnis, Wertstabilität, Lage
- Senioren → Barrierefreiheit, Aufzug, zentrale Versorgung
- Paare/Singles → Zentralität, Komfort, Sofortbezug
- Handwerker/Entwickler → Potenzial, Ausbaureserve, Grundstück`,
   },
   "Konservativ-Gehoben": {
      text: `Ziel-Milieu: Konservativ-Gehoben.
Werte & Lebensauffassung: Der verantwortungsbewusste etablierte Kern. Pflichtbewusstsein,
klassisch-bürgerliche Werte, Skepsis gegenüber zu schneller Modernisierung.
Tonalität: Seriös, gediegen, ruhig. Understatement statt Superlative.
Zuerst betonen: Klassisch und wertbeständig; echte Materialien (Parkett, Stein, Stuck);
gediegene Qualität, solides Handwerk statt Trend.
Entscheidungs- und Investitionsverhalten: Gründlich, langfristig, substanzorientiert; prüft
Bausubstanz und Werterhalt genau; lässt sich nicht drängen.
Erstbild-Empfehlung: Gepflegte Fassade / hochwertige Materialdetails (Parkett, Stuck).
Bevorzugte Begriffe: wertbeständig · gediegen · solide Bausubstanz · gewachsene Lage · zeitlos ·
hochwertig · über Generationen
Zu vermeiden: Schnäppchen · trendy · Hype · „must-have“ · reißerische Superlative · Anglizismen
Call-to-Action: Einladung zum gründlichen Gespräch, kein Zeitdruck.`,
   },
   Postmateriell: {
      text: `Ziel-Milieu: Postmateriell.
Werte & Lebensauffassung: Die engagiert-souveränen Bildungsbürger. Individualistisch, Erfolg
nicht über Status, bewusste Lebensführung und Lebensqualität zuerst.
Tonalität: Anspruchsvoll, ehrlich, reflektiert. Nie marktschreierisch.
Zuerst betonen: Authentisch und kultiviert; Originalsubstanz erhalten statt glattsanieren; Raum
für Bücher, Kunst, Persönliches.
Entscheidungs- und Investitionsverhalten: Reflektiert und werteorientiert; fragt nach Herkunft,
Geschichte, Ökobilanz; skeptisch gegenüber Verkaufsdruck.
Erstbild-Empfehlung: Charaktervolles Detail — Altbauelement, Lichtstimmung, Blick.
Bevorzugte Begriffe: charaktervoll · gewachsen · Originalsubstanz · Lebensqualität ·
lichtdurchflutet · individuell · kultiviert
Zu vermeiden: Statussymbol · exklusiv · Prestige · Rendite · „repräsentativ“ · aufgesetzte
Luxus-Begriffe
Call-to-Action: Angebot von Hintergrundinfos, Raum für eigene Abwägung.`,
   },
   Performer: {
      text: `Ziel-Milieu: Performer.
Werte & Lebensauffassung: Die effizienzorientierten Leistungs- und Fortschrittsverfechter.
Macher-Mentalität, hoher Anspruch an Stil und Lebensart.
Tonalität: Prägnant, hochwertig, selbstbewusst, auf den Punkt.
Zuerst betonen: Modern, klare Linien, Premium-Ausstattung; Smart Home, Architektenobjekte,
Neubau oder Penthouse; Design als Anspruch.
Entscheidungs- und Investitionsverhalten: Schnell und faktenbasiert; will Zahlen, Effizienz,
Wertsteigerungs- und Renditeargumente; schätzt einen straffen Prozess.
Erstbild-Empfehlung: Moderne Architektur, Premium-Ausstattung, Toplage-Perspektive.
Bevorzugte Begriffe: Premium · Architektur · effizient · Smart Home · Toplage · wertstabil ·
klare Linien · auf den Punkt
Zu vermeiden: verträumt · gemütlich · „kuschelig“ · langatmige Beschreibungen · vage
Wohlfühlfloskeln
Call-to-Action: Klarer nächster Schritt, straffer Termin, Zahlen auf Anfrage.`,
   },
   Expeditiv: {
      text: `Ziel-Milieu: Expeditiv.
Werte & Lebensauffassung: Die ambitioniert-kreativen Weltbürger. Zukunftsoptimismus,
Experimentierfreude, Selbstverwirklichung durch eigene Gestaltung.
Tonalität: Inspirierend, möglichkeitsorientiert, unkonventionell.
Zuerst betonen: Unkonventionell und wandelbar; offene Grundrisse, Industrial-Charme, Rohzustand
als Chance; Raum für eigene Ideen.
Entscheidungs- und Investitionsverhalten: Schnell und potenzialorientiert; reizoffen für das
Besondere; weniger Sicherheits-, mehr Gestaltungsfokus.
Erstbild-Empfehlung: Das Ungewöhnliche — offener Raum, Industrial-Detail, Weite.
Bevorzugte Begriffe: Gestaltungsspielraum · Potenzial · offen · wandelbar · besonders · Raum für
Ideen · aufstrebend
Zu vermeiden: bezugsfertig als Hauptargument · „nichts zu tun“ · spießig · betont
sicherheitsbetonte Sprache
Call-to-Action: Einladung, das Potenzial vor Ort selbst zu entdecken.`,
   },
   "Neo-Ökologisch": {
      text: `Ziel-Milieu: Neo-Ökologisch.
Werte & Lebensauffassung: Die progressiven Realisten. Werte- und Strukturwandel, pragmatisch im
Alltag umgesetzt; starker Gestaltungs- und Mitwirkungswille.
Tonalität: Konkret, ehrlich, sachlich-optimistisch. Kein Greenwashing.
Zuerst betonen: Nachhaltige Materialien, Effizienz und Funktionalität; PV, Wärmepumpe,
Begrünung; Substanz mit klarem Sanierungsstand.
Entscheidungs- und Investitionsverhalten: Pragmatisch, aber wertegeleitet; fragt konkret nach
Energiekennwerten, Sanierungsstand, Ökobilanz — Floskeln überzeugen nicht.
Erstbild-Empfehlung: Energie-Detail (PV, Wärmepumpe) oder begrüntes, helles Umfeld.
Bevorzugte Begriffe: energieeffizient · nachhaltig · sanierter Bestand · PV-Anlage · Wärmepumpe
· Sanierungsfahrplan · ÖPNV-nah
Zu vermeiden: Luxus · Prestige · Statement · pauschale „grüne“ Floskeln ohne Beleg ·
Statussymbol
Call-to-Action: Angebot von Energieausweis & Sanierungsfahrplan zur Prüfung.`,
   },
   "Adaptiv-Pragmatische Mitte": {
      text: `Ziel-Milieu: Adaptiv-Pragmatische Mitte.
Werte & Lebensauffassung: Die nutzenorientierte moderne Mitte. Lebenspragmatismus, Denken in
Optionen und Nutzen, starkes Bedürfnis nach Sicherheit und Zugehörigkeit.
Tonalität: Sachlich, freundlich, alltagsnah; klare, einfache Sprache.
Zuerst betonen: Modern-zeitlos, pflegeleicht, funktional; gute Ausstattung ohne Extravaganz;
bezugsfertig ist ein Plus.
Entscheidungs- und Investitionsverhalten: Abwägend, nutzen- und sicherheitsorientiert; achtet auf Finanzierbarkeit, Nebenkosten und Wiederverkaufbarkeit.
Erstbild-Empfehlung: Helles freundliches Haus oder gepflegter Garten — Familie wirkt willkommen.
Bevorzugte Begriffe: familienfreundlich · alltagstauglich · pflegeleicht · gute Anbindung ·
sicherer Stadtteil · bezugsfertig
Zu vermeiden: Luxus · exklusiv · Avantgarde · ungewöhnliche Architektur · Status-Vokabular
Call-to-Action: Klares Angebot mit Finanzierungshinweis; ohne Druck, mit Zahlen.`,
   },
   "Konsum-Hedonistisch": {
      text: `Ziel-Milieu: Konsum-Hedonistisch.
Werte & Lebensauffassung: Die konsumfreudigen Genuss- und Erlebnisorientierten. Lebensgenuss im
Alltag, Strategie des minimalen Aufwands.
Tonalität: Lebendig, einladend, sinnlich; das Lebensgefühl steht im Vordergrund.
Zuerst betonen: Gemütlich und komfortabel, modern-trendig, gut ausgestattet; einladend für
Freunde und Freizeit.
Entscheidungs- und Investitionsverhalten: Emotional und gegenwartsbezogen; schnell begeisterbar,
aber aufwandsscheu — Renovierungsobjekte schrecken ab.
Erstbild-Empfehlung: Lounge, Pool, Dachterrasse, Sunset — sichtbares Lebensgefühl.
Bevorzugte Begriffe: genießen · entspannen · stylisch · gemütlich · einziehen und wohlfühlen ·
bequem · Sonnenuntergang
Zu vermeiden: Sanierungsbedarf · Modernisierungspotenzial · Projekt · „liebevoll renovieren“
Call-to-Action: Einladung zum Erlebnis vor Ort; Termin schnell und unkompliziert.`,
      headline: `Stadtwohnung mit Dachterrasse — einziehen und genießen`,
   },
   "Nostalgisch-Bürgerlich": {
      text: `Ziel-Milieu: Nostalgisch-Bürgerlich.
Werte & Lebensauffassung: Die stabilitätsbedürftige Mitte. Streben nach Ordnung, Balance und
Sicherheit, Erfüllung im privaten Glück und stabilen Verhältnissen.
Tonalität: Warm, herzlich, vertrauensbildend; klassisch-bürgerlicher Klang.
Zuerst betonen: Gemütlich, gepflegt, vertraut und klassisch; Ordnung und ein Garten gehören
dazu.
Entscheidungs- und Investitionsverhalten: Sicherheitsorientiert und gründlich; fragt nach
Zustand, Nebenkosten, Nachbarschaft; braucht Vertrauen und Zeit.
Erstbild-Empfehlung: Familienhaus mit warmem Innenlicht; Garten, Schaukel, Hund.
Bevorzugte Begriffe: eigenes Häuschen · Familienleben · gepflegter Garten · Geborgenheit · Wärme
· Nachbarschaft
Zu vermeiden: Investment · Renditeobjekt · Single-Loft · Avantgarde · kühl-modernes Design
Call-to-Action: Persönliche, vertrauensvolle Einladung; viel Raum für Fragen.`,
      headline: `Familienhaus mit Garten — Geborgenheit für Generationen`,
   },
   Traditionell: {
      text: `Ziel-Milieu: Traditionell.
Werte & Lebensauffassung: Die Sicherheit und Ordnung liebende ältere Generation. Bodenständig,
an bewährten Lebensmodellen orientiert.
Tonalität: Schlicht, ehrlich, ruhig; verlässlich-bürgerlich.
Zuerst betonen: Schlicht, klassisch, vertraut; pflegeleicht und solide; keine Experimente.
Entscheidungs- und Investitionsverhalten: Vorsichtig, preis- und sicherheitsbewusst, eher
langsam; braucht viel Vertrauen, reagiert skeptisch auf Verkaufsdruck.
Erstbild-Empfehlung: Klassisches Haus oder Wohnung mit Bergblick/Allee; vertraute Form.
Bevorzugte Begriffe: gepflegt · barrierearm · überschaubar · vertraut · ruhige Lage ·
pflegeleicht
Zu vermeiden: modern · avantgardistisch · Loft · Investment · international
Call-to-Action: Ruhige, persönliche Einladung — wenn möglich beim Verkäufer-Erstgespräch.`,
      headline: "Gepflegtes Haus in ruhiger, vertrauter Lage",
   },
   Prekär: {
      text: `Ziel-Milieu: Prekär.
Werte & Lebensauffassung: Der um Zugehörigkeit und Respekt bemühte Teil der Gesellschaft.
Existenzsicherung im Alltag, starker Wunsch nach Anerkennung.
Tonalität: Klar, freundlich, würdevoll; keine Belehrung, keine Bevormundung.
Zuerst betonen: Funktional, ordentlich, gepflegt; keine besonderen Stilansprüche.
Entscheidungs- und Investitionsverhalten: Stark preis- und sicherheitsgetrieben; Sorge vor
finanzieller Überforderung; braucht Klarheit und Verlässlichkeit.
Erstbild-Empfehlung: Schlichte, helle und freundliche Wohnung; sauber, ordentlich, einladend.
Bevorzugte Begriffe: gepflegt · verlässlich · klar · freundlich · sicher · transparent ·
überschaubar
Zu vermeiden: Luxus · Investment · Exklusivität · Vermögensbildung · Statement
Call-to-Action: Einfaches, klares Angebot mit transparenten Kosten und Verfahren.`,
   },
};
const oldPrompt = `
Du bist ein erfahrener Immobilienmakler und Copywriter. Deine Aufgabe ist es, ein hochwertiges, verkaufsstarkes Immobilienexposé auf Deutsch zu schreiben.

  ### ALLE VERFÜGBAREN DATEN:
      $OBJEKT_DATEN

  ### ANWEISUNGEN FÜR DIE TONALITÄT:
  - Schreibstil: $SCHREIBSTIL.
  - Zielgruppe: Sprich die Zielgruppe $ZIELGRUPPE angemessen an.

  ### STRUKTUR DES EXPOSÉS (Bitte exakt einhalten und als einen gebündelten Fließtext):
  1. Analysiere die Daten und wähle die maximal 3 besten Highlights aus, die für Käufer den größten emotionalen oder praktischen Wert haben.
  2. Überschrift: Eine packende, kreative Headline (z. B. mit einem zentralen Highlight).
  3. **Einleitung (Der Haken)**: Ein kurzer, emotionaler Absatz, der Lust auf die Immobilie macht.
  4. **Die Highlights im Detail**: Beschreibe die genannten Highlights in flüssigen, bildhaften Sätzen.
  5. **Fazit & Call-to-Action**: Ein abschließender Satz, der den Leser dazu animiert, einen Besichtigungstermin zu vereinbaren.

  ### REGELN:
  - Die genaue Lage darf nicht genannt werden
  - Nutze kein Markdown, keine Hashtags, keine Nummerierung
  - Erfinde KEINE Daten dazu, die nicht oben genannt wurden (keine fiktiven Baujahre, Energieausweise).
  - Vermeide übertriebene Phrasen wie "Lichtdurchflutete Wohlfühloase" – sei stattdessen modern und präzise.
`;
